import React from 'react';

interface LoadingProps {
  size?: number;
}

export const Loading: React.FC<LoadingProps> = ( { size = 48 } ) => {
  return (
    <div className="flex flex-col items-center justify-center p-12">
      <div
        className="animate-spin rounded-full border-t-4 border-orange-base border-solid mb-4"
        style={{
          height: `${ size }px`,
          width: `${ size }px`,
        }}
      />
    </div>
  );
};